import { apiSlice } from '../../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({
    addTagTypes: ['SearchTag', 'FisheryTagging', 'TagIcons', 'AutoFilters'],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      getAllSearchTags: builder.query({
        query: () => ({
          url: `ops/search_tags`,
        }),
        providesTags: (result, error) => [
          ...(error ? [] : result.map(({ id }) => ({ type: 'SearchTag', id }))),
          { type: 'SearchTag', id: 'ALL' },
        ],
      }),

      getAllActiveSearchTags: builder.query({
        query: () => ({
          url: `ops/search_tags/active`,
        }),
        providesTags: (result, error) => [
          ...(error ? [] : result.map(({ id }) => ({ type: 'SearchTag', id }))),
          { type: 'SearchTag', id: 'ALL' },
        ],
      }),

      getAllFisheriesWithTags: builder.query({
        query: (body) => ({
          url: `ops/search_tags/fisheries`,
          data: body,
        }),
        providesTags: (result, error) => [
          ...(error
            ? []
            : result.flatMap((fmap) => [
                { type: 'FisheryTagging', id: fmap?.fishery_id },
                ...(fmap?.tag_ids ?? []).map((tagId) => ({
                  type: 'SearchTag',
                  id: tagId,
                })),
              ])),
          { type: 'FisheryTagging', id: 'ALL' },
          { type: 'SearchTag', id: 'ALL' },
        ],
      }),

      activateTag: builder.mutation({
        query: ({ tagId, active }) => ({
          url: `ops/search_tags/tag/active?tag_id=${tagId}&active=${active}`,
          method: 'PUT',
        }),
        invalidatesTags: (result, error, { tagId }) => [
          { type: 'SearchTag', id: tagId },
        ],
      }),

      changeTagOrder: builder.mutation({
        query: ({ tagId, moveDown }) => ({
          url: `ops/search_tags/tag/order?tag_id=${tagId}&increase=${moveDown}`,
          method: 'PUT',
        }),
        invalidatesTags: (result, error, { tagId }) => [
          { type: 'SearchTag', id: tagId },
        ],
      }),

      tagFishery: builder.mutation({
        query: ({ fisheryId, tagId, active }) => ({
          url: `ops/search_tags/fishery?fishery_id=${fisheryId}&tag_id=${tagId}&value=${active}`,
          method: 'PUT',
        }),
        invalidatesTags: (result, error, { fisheryId, tagId }) => [
          { type: 'FisheryTagging', id: fisheryId },
          { type: 'SearchTag', id: tagId },
        ],
      }),

      createNewTag: builder.mutation({
        query: (body) => ({
          url: `ops/search_tags/tag`,
          data: body,
          method: 'POST',
        }),
        invalidatesTags: [{ type: 'SearchTag', id: 'ALL' }],
      }),

      updateTagDetails: builder.mutation({
        query: ({ tagId, body }) => ({
          url: `ops/search_tags/tag?tag_id=${tagId}`,
          data: body,
          method: 'PUT',
        }),
        invalidatesTags: (result, error, { tagId }) => [
          { type: 'SearchTag', id: tagId },
        ],
      }),

      deleteTag: builder.mutation({
        query: (id) => ({
          url: `ops/search_tags/tag?tag_id=${encodeURIComponent(id)}`,
          method: 'DELETE',
        }),
        invalidatesTags: (result, error, tagId) => [
          { type: 'SearchTag', id: tagId }
        ],
      }),

      getTagIcons: builder.query({
        query: () => ({
          url: `ops/search_tags/icons`,
        }),
        providesTags: ['TagIcons'],
      }),

      getAutomaticFilterOptions: builder.query({
        query: () => ({
          url: `ops/search_tags/automatic_options`,
        }),
        providesTags: ['AutoFilters'],
      }),
    }),
  });

export const {
  useGetAllSearchTagsQuery,
  useGetAllActiveSearchTagsQuery,
  useGetAllFisheriesWithTagsQuery,
  useTagFisheryMutation,
  useActivateTagMutation,
  useChangeTagOrderMutation,
  useCreateNewTagMutation,
  useUpdateTagDetailsMutation,
  useDeleteTagMutation,
  useGetTagIconsQuery,
  useGetAutomaticFilterOptionsQuery,
} = extendedApiSlice;
